function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, orgs, submitted) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'select-org-modal-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-modal", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'closeable': $attr(`show-cancel`),
            open: $attr(`open`) && !submitted,
          }),
          "on": {
            submit: $helpers.handleSubmit
          },
          "class": {
            'select-org-modal': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-card-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-card-header-title': true
              },
            }, [__vjadeSafeCode($attr(`title-text`))]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'action-text': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Select Organization");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'input-area': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((orgs) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (orgs);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, org, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          click: () => $helpers.selectOrg(org)
                        },
                        "class": {
                          'org-card': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'org-card-container': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'org-name': true
                            },
                          }, [__vjadeSafeCode(org.name)]));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'caret-icon': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                icon: `caret-right`
                              }),
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var org = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              click: () => $helpers.selectOrg(org)
                            },
                            "class": {
                              'org-card': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'org-card-container': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'org-name': true
                                },
                              }, [__vjadeSafeCode(org.name)]));
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'caret-icon': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    icon: `caret-right`
                                  }),
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-skeleton-small': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-skeleton-small': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-skeleton-small': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-skeleton-small': true
                },
              }));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "orgs" in locals ? locals.orgs : typeof orgs !== "undefined" ? orgs : undefined, "submitted" in locals ? locals.submitted : typeof submitted !== "undefined" ? submitted : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;